import { useCallback, useEffect } from "react";
import FileUploadBtn from "../components/FileUploadBtn/FileUploadBtn";
import useFileUpload from "../hooks/useFileUpload";

// 전역으로 로딩상태를 관리하면 안됨
// 모든 버튼의 데이터 ,로딩 상태가 공유되어버리잖아
// 버튼 하나하나의 지역적 상태로 관리해야 한다 .!!!!

// 다 엎기는 좀 아까운데 .. 다른 컴포넌트의 로직을 유지하고
// 전역상태를 지역상태로만 바꿔보자 -> useAsync 때를 기억하자

const FileUploadBtnContainer = (props) => {
  // fileChange가 Addform 과 EditForm 에서 다르게 받아와져서 생기는
  // useEffect 문제 있음

  const { onFileChange, fileName } = props;

  const [state, postData] = useFileUpload();
  const { data, error, loading } = state;

  const handleFileUpload = useCallback(
    (file) => {
      postData(file);
    },
    [postData]
  );

  useEffect(() => {
    if (data) {
      // data가 성공적으로 불러왔을시 파일 변경함
      // 데이터 변경
      onFileChange(data);
    }
    // deps 배열에 onFileChange를 없애니까 무한반복 없어졌다.
    // eslint 워닝을 없애버렸다.
    // 이 문제는 컴포넌트 렌더링 최적화 때 하나하나 따져보기로 한다.
    // eslint-disable-next-line
  }, [data]);

  if (error) alert("업로드 오류");

  return (
    <FileUploadBtn
      fileName={fileName}
      loading={loading}
      onFileUpload={handleFileUpload}
    />
  );
};

export default FileUploadBtnContainer;
